// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Button, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { PROJECTS_ROUTE } from 'Utils/routes';
import stylesDef from './styles';

interface IFolderBreadcrumbProps {
  // The trailing crumb: the folder page passes its editable folder name, the map rail the
  // folder's name as text.
  children: React.ReactNode;
  // Leaving the folder in place, for a surface that has nowhere to navigate to - the map
  // rail clears its folder without closing the map. Omitted, the crumb links to the
  // dashboard, so a middle-click still opens it in a new tab.
  onAllProjectsClick: (() => void) | undefined;
}

// AUT-6432: All Projects > this folder, wherever a folder is open - the folder page and the
// map rail. One component, so the two cannot describe the same position differently.
export const FolderBreadcrumb = ({ children, onAllProjectsClick }: IFolderBreadcrumbProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  const allProjectsLabel = <Typography variant="body1" sx={styles.allProjectsText}>All Projects</Typography>;

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      {onAllProjectsClick ? (
        <Button sx={styles.allProjectsButton} onClick={onAllProjectsClick}>{allProjectsLabel}</Button>
      ) : (
        <Button component={RouterLink} to={PROJECTS_ROUTE} sx={styles.allProjectsButton}>{allProjectsLabel}</Button>
      )}
      <Box sx={styles.currentCrumb}>{children}</Box>
    </Breadcrumbs>
  );
};

export default FolderBreadcrumb;
